import { Spinner } from "@afterpaytouch/core";
import classnames from "classnames/bind";
import dynamic from "next/dynamic";
import React from "react";

import { useIsArcade } from "@/hooks/useIsArcade";

import LogoAnimation from "../../assets/animations/mint-logo-transparent-bg.json";
import styles from "./loader.module.scss";

// Lottie uses browser DOM APIs at import time, including when Node exposes navigator.
const Lottie = dynamic(() => import("react-lottie-player"), { ssr: false });

const cx = classnames.bind(styles);

const Loader: React.FC = () => {
    const isArcade = useIsArcade();
    const loaderClassName = cx({
        [styles.loaderContainer]: true,
        [styles.loaderContainerArcade]: isArcade,
    });
    return (
        <div className={loaderClassName}>
            {isArcade ? (
                <Spinner />
            ) : (
                <Lottie
                    animationData={LogoAnimation}
                    rendererSettings={{
                        preserveAspectRatio: "xMidYMid slice",
                    }}
                    loop
                    play
                />
            )}
        </div>
    );
};

export default Loader;
